import React, { useEffect, useState } from "react";
import NavMobile from "../../Nav/NavMobile";
import NavWeb from "../../Nav/NavWeb";
import { Button } from "../../../ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../ui/table";
import { TrashIcon } from "@radix-ui/react-icons";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../../../ui/alert-dialog";
import "./ProfesorDetalle.css";
import { Dialog, DialogContent, DialogTrigger } from "../../../ui/dialog";
import { BellIcon, DownloadIcon } from "@radix-ui/react-icons";
import Calendar from "../../EstudiantesPrivados/Dashboard/Calendar";
import Loader from "../../../Loader/Loader";
import ClickOnClassTeamAdmin from "./ClickOnClassTeamAdmin";
import ClickOnClassEstudentDetailAdmin from "./ClickOnClassEstudentDetailAdmin";
import CrearEditarProfesorBankData from "../CrearEditProfesorBankData";
import { getClassesByTeacherAndDateTimeBetween } from "../../../../provider/adm/Clases/getClassesByTeacherAndDateTimeBetween";
import { dashboardTeacher } from "../../../../provider/adm/dashboard/dashboardTeacher";
import { Toaster } from "sonner";
import { Pencil1Icon } from "@radix-ui/react-icons";
import EditarClasesEnMasa from "../../EstudiantesPrivados/Dashboard/EditarClasesEnMasa";
import { deleteClass } from "../../../../provider/adm/Clases/deleteClass";
import AdditionalPaymentsDialog from "./AdditionalPaymentsDialog";
import { PlusSquare, ExternalLink } from "lucide-react";

const ProfesoresDashboard = () => {
  const [profesorData, setProfesorData] = useState(null);
  const [classes_estudiante, setClassesEstudiante] = useState([]);
  const [teacherInfoClasses, setTeacherInfoClasses] = useState([]);
  const [date, setDate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [selectedClasses, setSelectedClasses] = useState([]);

  // Add state for additional payments dialog
  const [additionalPaymentsDialog, setAdditionalPaymentsDialog] = useState(false);

  // Estados para los filtros
  const [filters, setFilters] = useState({
    idClase: '',
    fecha: '',
    participanteId: ''
  });

  // Función para manejar cambios en los filtros
  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  // Función para limpiar filtros
  const clearFilters = () => {
    setFilters({
      idClase: '',
      fecha: '',
      participanteId: ''
    });
  };

  // Función para filtrar las clases
  const filteredClasses = classes_estudiante.filter(classData => {
    const matchesId = !filters.idClase ||
      classData.id.toString().toLowerCase().includes(filters.idClase.toLowerCase());

    const matchesFecha = !filters.fecha ||
      new Date(classData.dateTime).getDate().toString() === filters.fecha;

    const matchesParticipante = !filters.participanteId ||
      classData.participantID.toString().toLowerCase().includes(filters.participanteId.toLowerCase());

    return matchesId && matchesFecha && matchesParticipante;
  });

  // Función para manejar la selección individual
  const handleSelectClass = (classId) => {
    setSelectedClasses((prev) =>
      prev.includes(classId)
        ? prev.filter((id) => id !== classId)
        : [...prev, classId]
    );
  };

  // Función para seleccionar/deseleccionar todas
  const handleSelectAll = () => {
    if (selectedClasses.length === filteredClasses.length && filteredClasses.length > 0) {
      setSelectedClasses([]);
    } else {
      setSelectedClasses(filteredClasses.map((c) => c.id));
    }
  };
  const handleMassEditSuccess = async () => {
    await refreshData();
    setSelectedClasses([]); // Limpiar selecciones
  };

  // Función para eliminar clases seleccionadas
  const handleDeleteSelected = async () => {
    if (selectedClasses.length === 0) return;

    const confirmReturnHours = window.confirm(
      "¿Deseas devolver las horas?"
    );

    setLoading(true);
    try {
      // Eliminar cada clase seleccionada una por una
      for (const classId of selectedClasses) {
        await deleteClass(classId, confirmReturnHours);
      }
      await refreshData();
      setSelectedClasses([]); // Limpiar selecciones
    } catch (error) {
      console.error("Error eliminando las clases:", error);
    } finally {
      setLoading(false);
    }
  };

  // Función para recargar datos
  const refreshData = async () => {
    if (window.refreshCalendarData) {
      await window.refreshCalendarData();
    } else {
      // Fallback: incrementa el trigger para forzar la recarga
      setRefreshTrigger((prev) => prev + 1);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const data = localStorage.getItem("selected_teacher");
      if (data) {
        setProfesorData(JSON.parse(data));
      }
      const storedDate = localStorage.getItem("teacher_dashboard_date");
      if (storedDate) {
        setDate(JSON.parse(storedDate));
      } else {
        setDate({
          month: parseInt(new Date().getMonth().toString()) + 1,
          year: new Date().getFullYear().toString(),
        });
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (date && date.month && date.year) {
      localStorage.setItem("teacher_dashboard_date", JSON.stringify(date));
    }
  }, [date]);

  const exportToExcel = async () => {
    try {
      setLoading(true);

      // Use the current date state values for the export
      const { year, month } = date;

      // Create the API URL with query parameters
      const apiUrl = `${process.env.REACT_APP_API_URL}/admin/profesor/exportar-profesores?year=${year}&month=${month}`;
      const token = sessionStorage.getItem("token"); // Retrieve the JWT token from session storage

      // Fetch the Excel file from the API
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      });

      if (!response.ok) {
        throw new Error(`Error al exportar: ${response.status}`);
      }

      // Get the file as a blob
      const blob = await response.blob();

      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create filename
      const fileName = `Profesores_${year}_${month}.xlsx`;

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.setAttribute("download", fileName);

      // Set additional attributes to try to force the save dialog
      link.setAttribute(
        "type",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
      link.setAttribute("target", "_blank");

      // Append to the document, trigger click, and then remove
      document.body.appendChild(link);
      link.click();

      // Remove the element and revoke the object URL to free up memory
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("Error al exportar el archivo Excel:", error);
      // You could use the Toaster here to show an error message
    } finally {
      setLoading(false);
    }
  };

  if (!profesorData) {
    return <Loader />;
  }

  return (
    <div
      className="min-h-screen flex"
      style={{ overflowY: "hidden", height: "100vh" }}
    >
      {loading && <Loader />}
      <NavMobile />
      <NavWeb />
      <div className="dashboardprofesor">
        <div className="dashboardcontainergroup">
          {/* Add the AdditionalPaymentsDialogAdmin component */}
          <AdditionalPaymentsDialog
            isOpen={additionalPaymentsDialog}
            onClose={() => setAdditionalPaymentsDialog(false)}
            teacherId={profesorData.id}
            teacherName={profesorData.fullName}
            date={date}
          />

          <div className="tituloynotificaciones">
            <h2 className="text-xl font-bold text-gray-900">
              Profesor {profesorData.fullName} con id {profesorData.id}
            </h2>
            <BellIcon className="h-6 w-6" />
          </div>
          <div className="filtrosandbackbtn">
            <a href="/admin/profesores/activos">
              <Button>Back</Button>
            </a>
            <div className="actions">
              <Calendar
                setDate={(date) => setDate(date)}
                date={date}
                ID={profesorData.id}
                setClasses={setClassesEstudiante}
                getClasses={getClassesByTeacherAndDateTimeBetween}
                getInforDashboard={dashboardTeacher}
                setInforDashboard={setTeacherInfoClasses}
                setLoading={setLoading}
                refreshTrigger={refreshTrigger}
              />

              <Button
                onClick={() => {
                  const currentDate = new Date();
                  const dateObj = {
                    month: (currentDate.getMonth() + 1).toString(),
                    year: currentDate.getFullYear().toString(),
                  };
                  setDate(dateObj);
                  localStorage.removeItem("teacher_dashboard_date");
                }}
              >
                limpiar filtros
              </Button>
              <Button onClick={exportToExcel}>
                <DownloadIcon />
                Exportar
              </Button>
            </div>
          </div>
          <div className="resumenDeActividadAcademica">
            <h3 className="text-xl font-bold mb-4 text-gray-800">Resumen de Actividad Académica</h3>
            
            {/* Sección de Horas */}
            <div className="mb-6">
              <h4 className="text-lg font-semibold mb-3 text-blue-600 border-b border-blue-200 pb-1">📚 Horas del Mes</h4>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="actividadCard bg-blue-50 border-l-4 border-blue-500">
                  <h5 className="text-sm font-medium text-gray-600">Horas Planeadas</h5>
                  <p className="text-2xl font-bold text-blue-600">{teacherInfoClasses.hoursPlanned || 0}</p>
                </div>
                <div className="actividadCard bg-purple-50 border-l-4 border-purple-500">
                  <h5 className="text-sm font-medium text-gray-600">Horas Virtuales</h5>
                  <p className="text-2xl font-bold text-purple-600">{teacherInfoClasses.hoursHeldVirtual || 0}</p>
                </div>
                <div className="actividadCard bg-orange-50 border-l-4 border-orange-500">
                  <h5 className="text-sm font-medium text-gray-600">Horas Presenciales</h5>
                  <p className="text-2xl font-bold text-orange-600">{teacherInfoClasses.hoursHeldInPerson || 0}</p>
                </div>
                <div className="actividadCard bg-green-50 border-l-4 border-green-500">
                  <h5 className="text-sm font-medium text-gray-600">Horas Dictadas Totales</h5>
                  <p className="text-2xl font-bold text-green-600">{teacherInfoClasses.hoursHeld || 0}</p>
                </div>
              </div>
            </div>

            {/* Sección de Cancelaciones */}
            <div className="mb-6">
              <h4 className="text-lg font-semibold mb-3 text-red-600 border-b border-red-200 pb-1">❌ Horas Canceladas</h4>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                <div className="actividadCard bg-yellow-50 border-l-4 border-yellow-500">
                  <h5 className="text-sm font-medium text-gray-600">A Tiempo (Estudiante)</h5>
                  <p className="text-2xl font-bold text-yellow-600">{teacherInfoClasses.hoursCanceledParticipantOnTime || 0}</p>
                </div>
                <div className="actividadCard bg-amber-50 border-l-4 border-amber-500">
                  <h5 className="text-sm font-medium text-gray-600">A Tiempo (Profesor)</h5>
                  <p className="text-2xl font-bold text-amber-600">{teacherInfoClasses.hoursCanceledTeacherOnTime || 0}</p>
                </div>
                <div className="actividadCard bg-orange-50 border-l-4 border-orange-500">
                  <h5 className="text-sm font-medium text-gray-600">Tarde (Estudiante)</h5>
                  <p className="text-2xl font-bold text-orange-600">{(teacherInfoClasses.hoursCanceledParticipantLateVirtual || 0) + (teacherInfoClasses.hoursCanceledParticipantLateInPerson || 0)}</p>
                </div>
                <div className="actividadCard bg-red-50 border-l-4 border-red-500">
                  <h5 className="text-sm font-medium text-gray-600">Tarde (Profesor)</h5>
                  <p className="text-2xl font-bold text-red-600">{teacherInfoClasses.hoursCanceledTeacherLate || 0}</p>
                </div>
                <div className="actividadCard bg-pink-50 border-l-4 border-pink-500">
                  <h5 className="text-sm font-medium text-gray-600">Tarde Virtual</h5>
                  <p className="text-2xl font-bold text-pink-600">{teacherInfoClasses.hoursCanceledParticipantLateVirtual || 0}</p>
                </div>
                <div className="actividadCard bg-rose-50 border-l-4 border-rose-500">
                  <h5 className="text-sm font-medium text-gray-600">Tarde Presencial</h5>
                  <p className="text-2xl font-bold text-rose-600">{teacherInfoClasses.hoursCanceledParticipantLateInPerson || 0}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="informacionDetalladaEstudiante">
            <CrearEditarProfesorBankData personal_info_teacher={profesorData} />
          </div>
          <div className="totales bg-white shadow-md rounded-lg p-6 text-sm">
            <h2 className="text-2xl font-bold mb-4">Totales del Mes</h2>
            <div className="invoice space-y-4">
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Horas Totales Planeadas:</span>
                <span>{teacherInfoClasses.hoursPlanned || 0} horas</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Horas Totales Dictadas:</span>
                <span>{teacherInfoClasses.hoursHeld || 0} horas</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Clases Virtuales Dictadas:</span>
                <span>{teacherInfoClasses.classesHeldVirtual || 0} clases</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Clases Presenciales Dictadas:</span>
                <span>{teacherInfoClasses.classesHeldInPerson || 0} clases</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Horas Virtuales:</span>
                <span>{teacherInfoClasses.hoursHeldVirtual || 0} horas</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Horas Presenciales:</span>
                <span>{teacherInfoClasses.hoursHeldInPerson || 0} horas</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Canceladas a Tiempo (Estudiante):</span>
                <span>{teacherInfoClasses.hoursCanceledParticipantOnTime || 0} horas</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Canceladas a Tiempo (Profesor):</span>
                <span>{teacherInfoClasses.hoursCanceledTeacherOnTime || 0} horas</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">
                  Tarde Canceladas por Estudiante (Virtual):
                </span>
                <span>
                  {teacherInfoClasses.hoursCanceledParticipantLateVirtual || 0}{" "}
                  horas
                </span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">
                  Tarde Canceladas por Estudiante (Presencial):
                </span>
                <span>
                  {teacherInfoClasses.hoursCanceledParticipantLateInPerson || 0}{" "}
                  horas
                </span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">
                  Hrs Tarde Canceladas por Profesor:
                </span>
                <span>
                  {teacherInfoClasses.hoursCanceledTeacherLate || 0} horas
                </span>
              </div>
              
              <div className="mt-6 pt-4 border-t-2 border-gray-300">
                <h3 className="text-lg font-bold mb-3">Información Financiera</h3>
              </div>
              
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Valor Total Virtual:</span>
                <span>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                  }).format(
                    (teacherInfoClasses.totalVirtualValue || 0) + (teacherInfoClasses.totalVirtualCancelledValue || 0)
                  )}
                </span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Valor Total Presencial:</span>
                <span>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                  }).format(
                    (teacherInfoClasses.totalInPersonValue || 0) + (teacherInfoClasses.totalInPersonCancelledValue || 0)
                  )}
                </span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Valor Cancelaciones Virtuales:</span>
                <span>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                  }).format(
                    (teacherInfoClasses.totalVirtualCancelledValue || 0)
                  )}
                </span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Valor Cancelaciones Presenciales:</span>
                <span>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                  }).format(
                    (teacherInfoClasses.totalInPersonCancelledValue || 0)
                  )}
                </span>
              </div>
              <div
                className="invoice-item flex justify-between border-b pb-2 cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                onClick={() => setAdditionalPaymentsDialog(true)}
              >
                <span className="font-semibold flex items-center">
                  <PlusSquare className="inline w-4 h-4 mr-2" />
                  Pagos Adicionales:
                </span>
                <span>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                  }).format(
                    (teacherInfoClasses.totalAdditionalPays || 0)
                  )}
                </span>
              </div>
              <div className="invoice-item flex justify-between text-xl font-bold mt-4 pt-4 border-t-2 border-gray-600">
                <span>Total a Pagar:</span>
                <span className="text-green-600">
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                  }).format(
                    (teacherInfoClasses.totalToPay || 0)
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="ultimas_clases_estudiante">
            <div className="flex justify-between items-center mb-4">
              <h2>
                <b>Clases de los participantes</b>
              </h2>

              {/* Botón de eliminar seleccionadas - solo aparece cuando hay selecciones */}
              {selectedClasses.length > 0 && (
                <div className="flex gap-2">
                  <AlertDialog>
                    <AlertDialogTrigger asChild>
                      <Button variant="destructive">
                        <TrashIcon className="w-4 h-4 mr-2" />
                        Eliminar Seleccionadas ({selectedClasses.length})
                      </Button>
                    </AlertDialogTrigger>
                    <AlertDialogContent>
                      <AlertDialogHeader>
                        <AlertDialogTitle>¿Estás absolutamente seguro?</AlertDialogTitle>
                        <AlertDialogDescription>
                          Esta acción no se puede deshacer. Esto eliminará
                          permanentemente {selectedClasses.length} clase(s) y todos
                          sus datos asociados.
                        </AlertDialogDescription>
                      </AlertDialogHeader>
                      <AlertDialogFooter>
                        <AlertDialogCancel>Cancelar</AlertDialogCancel>
                        <AlertDialogAction onClick={handleDeleteSelected}>
                          Sí, eliminar
                        </AlertDialogAction>
                      </AlertDialogFooter>
                    </AlertDialogContent>
                  </AlertDialog>

                  <Dialog>
                    <DialogTrigger asChild>
                      <Button variant="outline">
                        <Pencil1Icon className="w-4 h-4 mr-2" />
                        Editar Seleccionadas ({selectedClasses.length})
                      </Button>
                    </DialogTrigger>
                    <DialogContent className="sm:max-w-[600px]">
                      <EditarClasesEnMasa
                        selectedClasses={selectedClasses.map(id =>
                          filteredClasses.find(cls => cls.id === id)
                        ).filter(Boolean)}
                        onSuccess={handleMassEditSuccess}
                      />
                    </DialogContent>
                  </Dialog>
                </div>
              )}
            </div>

            {/* Filtros */}
            <div className="filters-section bg-gray-50 p-4 rounded-lg mb-4">
              <h3 className="text-lg font-semibold mb-3">Filtros</h3>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    ID Clase
                  </label>
                  <input
                    type="text"
                    placeholder="Buscar por ID..."
                    value={filters.idClase}
                    onChange={(e) => handleFilterChange('idClase', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Fecha (Día)
                  </label>
                  <input
                    type="number"
                    placeholder="Día (1-31)"
                    min="1"
                    max="31"
                    value={filters.fecha}
                    onChange={(e) => handleFilterChange('fecha', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Participante ID
                  </label>
                  <input
                    type="text"
                    placeholder="ID del participante..."
                    value={filters.participanteId}
                    onChange={(e) => handleFilterChange('participanteId', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div className="flex items-end">
                  <Button
                    variant="outline"
                    onClick={clearFilters}
                    className="w-full"
                  >
                    Limpiar Filtros
                  </Button>
                </div>
              </div>
            </div>

            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>
                    <input
                      type="checkbox"
                      checked={
                        selectedClasses.length === filteredClasses.length &&
                        filteredClasses.length > 0
                      }
                      onChange={handleSelectAll}
                      className="rounded"
                    />
                  </TableHead>
                  <TableHead>ID clase</TableHead>
                  <TableHead>Fecha</TableHead>
                  <TableHead>Participante ID</TableHead>
                  <TableHead>Participante</TableHead>
                  <TableHead>Modalidad</TableHead>
                  <TableHead>H. planeadas</TableHead>
                  <TableHead>Duracion</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredClasses.map((classData) => (
                  <TableRow
                    key={classData.id}
                    className={
                      selectedClasses.includes(classData.id)
                        ? "bg-blue-50 border-blue-200"
                        : ""
                    }
                  >
                    <TableCell>
                      <input
                        type="checkbox"
                        checked={selectedClasses.includes(classData.id)}
                        onChange={() => handleSelectClass(classData.id)}
                        className="rounded"
                      />
                    </TableCell>
                    <TableCell>{classData.id}</TableCell>
                    <TableCell>
                      {new Date(classData.dateTime).toLocaleString("es", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                        timeZoneName: "short",                         
                      })}
                    </TableCell>
                    <TableCell>{classData.participantID}</TableCell>
                    <TableCell>{classData.classScope}</TableCell>
                    <TableCell>{classData.classType}</TableCell>
                    <TableCell>{classData.plannedDuration} H</TableCell>
                    <TableCell>{classData.duration} H</TableCell>
                    <TableCell>
                      <div
                        className={`flex items-center justify-center p-1 rounded-lg text-white font-semibold ${classData.classStatus === "Held"
                            ? "bg-green-500"
                            : classData.classStatus === "To be held"
                              ? "bg-gray-500"
                              : classData.duration > 0
                                ? "bg-orange-500"
                                : "bg-red-500"
                          }`}
                      >
                        <span className="w-2 h-2 rounded-full mr-3 bg-white"></span>
                        <span>
                          {classData.classStatus === "To be held"
                            ? "Por llenar"
                            : classData.classStatus === "Held"
                              ? "Completada"
                              : classData.duration > 0
                                ? "Parcial"
                                : "Cancelada"}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell className="flex space-x-2">
                      <Dialog>
                        <DialogTrigger asChild>
                          <button>
                            <span className="text-sm text-blue-600 cursor-pointer">
                              Ver detalles
                            </span>
                          </button>
                        </DialogTrigger>
                        <DialogContent className="sm:max-w-[425px] p-4">
                          {classData.classScope === "Team" ? (
                            <ClickOnClassTeamAdmin
                              teamID={classData.participantID}
                            />
                          ) : (
                            <ClickOnClassEstudentDetailAdmin
                              studentId={classData.participantID}
                            />
                          )}
                        </DialogContent>
                      </Dialog>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            {filteredClasses.length === 0 && classes_estudiante.length > 0 && (
              <div className="text-center py-8 text-gray-500">
                No se encontraron clases que coincidan con los filtros aplicados.
              </div>
            )}
          </div>
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default ProfesoresDashboard;
